(ns motorsaif.web.admin.businesses
  (:require
   [motorsaif.web.components :as c]
   [motorsaif.time :as time]
   [motorsaif.url :as url]
   [motorsaif.web.components.tabular :as tabular]
   [motorsaif.frontend-routes :as routes]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.core :as r]))

(defn root []
  (let [businesses @(subscribe [:admin-data :businesses])
        data (map (fn [{id :db/id
                        {loc-name :location/name} :business/location
                        :business/keys [name description created last-seen media] :as biz}]
                    (let [
                          last-seen (or (time/default-ago-str-date last-seen) "N/A")
                          created (or (time/default-ago-str-date created) "N/A")
                          visible [{:type :img
                                    :val (url/uploaded-media {:media (first (sort-by :media/order media))
                                                              :size :med})}
                                   {:title "Name"
                                    :val name}
                                   {:title "Created"
                                    :val created}
                                   {:title "Last Seen"
                                    :val last-seen}
                                   {:title "Location"
                                    :val loc-name}]
                          hidden [(fn []
                                    [:div.grid.col-2.fw
                                     [:a.btn.primary {:href
                                                      (routes/path-for :public-profile {:id id})} "View"]
                                     " "
                                     [:a.btn.primary {:href
                                                      (routes/path-for :admin-entity {:table :businesses
                                                                                      :id id})} "Edit"]])]]
                      {:visible visible
                       :hidden hidden}))
                  (reverse (sort-by :business/created businesses)))]
    [:div.content.container
     [:a.btn.primary {:href
                      (routes/path-for :admin-new-entity
                                       {:table :businesses})}
      "Add New"]
     [tabular/table data]]))
